import React from 'react';
import type { PropsWithChildren } from 'react';
import useHashParam from 'use-hash-param';
import { useRouterState } from '@tanstack/react-router';

import { useAuth } from '@reckon-web/auth-store';

import { isSecureRoute } from '../Navigation';

export type UrlFragmentManagerProps = PropsWithChildren<{}>;

export const UrlFragmentManager = ({ children }: UrlFragmentManagerProps) => {
  const pathname = useRouterState({
    select: (state) => {
      return state.location.pathname;
    },
  });
  const [accessToken, setAccessToken] = useHashParam('accessToken', '');

  const { credentials, setCredentials, isLoading, setIsLoading } = useAuth();

  React.useEffect(() => {
    if (!isSecureRoute(pathname)) {
      setIsLoading(false);
      return;
    }

    if (!!isLoading && !!accessToken && accessToken !== 'null') {
      setCredentials({ accessToken });
      setAccessToken('');
      setIsLoading(false);
      return;
    }

    if (isLoading) {
      setIsLoading(false);
      return;
    }
  }, [
    accessToken,
    credentials?.accessToken,
    isLoading,
    pathname,
    setAccessToken,
    setCredentials,
    setIsLoading,
  ]);

  return <>{children}</>;
};
